import PropTypes from 'prop-types';
import inputTypes from '../FormInput/inputTypes';
import cx from 'classnames';
import './style.scss';

export default function FormInput({
  id = '',
  name = '',
  labelClass = '',
  inputClass = '',
  wrapClass = '',
  errorLabelClass = '',
  value = '',
  label = '',
  type = inputTypes.text,
  errorMessage = null,
  checked = false,
  ...props
}) {
  const inputLabel = (
    <label htmlFor={id} className={`input__label ${labelClass}`}>
      {label}
    </label>
  );

  const errorLabel = (
    <label htmlFor={id} className={`input__label input__label--error ${errorLabelClass}`}>
      {errorMessage}
    </label>
  );

  return (
    <div className={`input__wrap ${wrapClass}`}>
      {label && type !== inputTypes.radio && inputLabel}
      <input
        id={id}
        name={name}
        value={value || ''}
        checked={checked}
        type={type}
        className={cx('input__field', {
          checkbox: type === inputTypes.checkbox,
          radio: type === inputTypes.radio
        })}
        {...props}
      />
      {label && type === inputTypes.radio && inputLabel}
      {errorMessage && errorLabel}
    </div>
  );
}

FormInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  labelClass: PropTypes.string,
  errorLabelClass: PropTypes.string,
  inputClass: PropTypes.string,
  wrapClass: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  type: PropTypes.string,
  errorMessage: PropTypes.string
};
